module.exports = __webpack_public_path__ + "img/ic-delivery.191401bc.svg";